import { Api } from '@axiom/ui';
import type { Candidate, User } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';
import LegacyApiHelper from '../classes/legacy-api-helper';

class TalentCollaboratorsLegacyApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
    });
  }

  readCollaborators(candidateId: Candidate['id']) {
    return super.read<{ data: User[] }>({
      endpoint: `/candidates/${candidateId}/users`,
      method: 'GET',
    });
  }

  async refreshCollaborators(candidateId: Candidate['id']) {
    return super.invalidate(`/candidates/${candidateId}/users`);
  }

  async updateCollaborators(
    candidateId: Candidate['id'],
    body: Array<User['id']>
  ) {
    return super.write<{ data: { talentId: Candidate['id']; id: User['id'] } }>(
      {
        endpoint: `/candidates/${candidateId}/users`,
        body,
        method: 'PUT',
      }
    );
  }
}

export const TalentCollaboratorsLegacyApi =
  new TalentCollaboratorsLegacyApiClass();

const api = new LegacyApiHelper('talent-collaborators');

export const getCollaboratorsByTalentId = async (talentId: Candidate['id']) => {
  const response = await api.GET(
    `${EnvUtil.apiEnvoyUrl}/candidates/${talentId}/users`
  );
  return {
    data: response.data,
  };
};

export const postCollaboratorsByTalentId = async (
  talentId: Candidate['id'],
  collaborators: User[]
) => {
  const collaboratorIds = collaborators.map(c => c.id);
  const response = await TalentCollaboratorsLegacyApi.updateCollaborators(
    talentId,
    collaboratorIds
  );
  return {
    talentId: response.data,
    id: talentId,
  };
};
